import React, { useState, useEffect, useContext } from 'react';
import { TfiMenuAlt } from 'react-icons/tfi';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { GoSearch } from 'react-icons/go';
import "./css/Leads.css"
import axios from "axios"
import AddLead from '../components/AddLead';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    IconButton,
    Modal,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Popover,
    Typography,
    Grid,
    Divider
} from '@mui/material';
import { Link, Outlet } from 'react-router-dom';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import api from "../config/backend";
import search from '../assets/icons/search.svg';
import pdf from '../assets/icons/pdf.svg';
import filter from '../assets/icons/filter.svg';
import upload from '../assets/icons/upload.svg';
import leadslist from '../assets/icons/leads-list.svg';
import leadstable from '../assets/icons/leads-table.svg'
import { FileDownload } from '@mui/icons-material';
import DownloadExportData from '../utils/excel';

const Leads = (props) => {
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [searchLead, setSearchLead] = useState("");
    const [isSearchLeadVisible, setIsSearchLeadVisible] = useState(false);
    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [employees, setEmployees] = useState([]);
    const token = localStorage.getItem("_crm__token");

    // Filter states
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [filters, setFilters] = useState({
        employeeId: "",
        startDate: "",
        endDate: ""
    });
    const [filtersApplied, setFiltersApplied] = useState(false);

    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    // Filter popover handlers
    const handleFilterClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
        // Fetch employees for the dropdown if not already loaded
        if (employees.length === 0) {
            fetchEmployees();
        }
    };

    const handleFilterClose = () => {
        setFilterAnchorEl(null);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const applyFilters = () => {
        setFiltersApplied(true);
        fetchLeads(filters);
        handleFilterClose();
    };

    const clearFilters = () => {
        setFilters({
            employeeId: "",
            startDate: "",
            endDate: ""
        });

        setFiltersApplied(false);
        fetchLeads({
            employeeId: "",
            startDate: "",
            endDate: ""
        });
        handleFilterClose();
    };

    const fetchEmployees = async () => {
        try {
            const response = await axios.get(`${api}/Employee/get`);
            if (response.data.success) {
                setEmployees(response.data.employees);
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const fetchLeads = async (filters) => {
        try {
            const { data, status } = await axios.post(`${api}/Leads/getleads`, {
                token,
                view: "list",
                employeeId: filters.employeeId || undefined,
                startDate: filters.startDate || undefined,
                endDate: filters.endDate || undefined
            });

            if (data.success) {
                const formattedRows = data.leads.map((item, index) => {
                    const copy = { ...item };
                    copy.id = index + 1;
                    if (Array.isArray(copy.tags) && copy.tags.length > 0) {
                        copy.tags = copy.tags.map(tag => tag.name).join(', ');
                    } else {
                        copy.tags = '';
                    }

                    return copy;
                });

                setRows(formattedRows);
            } else {
                console.log({ data });
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
        }
    };

    const handleDownloadExcel = async (filters) => {
        try {
            // Using axios to download the file
            const response = await axios({
                url: `${api}/Leads/getleads`,
                method: 'POST',
                responseType: 'blob', // Important for file downloads
                data: {
                    token,
                    view: "list",
                    employeeId: filters?.employeeId || undefined,
                    startDate: filters?.startDate || undefined,
                    endDate: filters?.endDate || undefined,
                    download: true
                }
            });

            DownloadExportData(response.data, 'Leads.csv');

        } catch (error) {
            console.error('Error downloading Excel file:', error);
            alert('Failed to download Excel file');
        }
    };

    useEffect(() => {
        fetchLeads(filters);
    }, [triggerRefresh]);

    const isFilterOpen = Boolean(filterAnchorEl);
    const filterId = isFilterOpen ? 'filter-popover' : undefined;


    return (
        <div className='app-new-leads'>
            <div className="employee-header">
                <div className='sub-nav__left'>
                    {/* <div className='sub-nav__toggles'>
                        <Link to='/leads/leads-view'>
                            <img src={leadstable} />
                        </Link>
                        <Link to='/leads/leads-pipe-view'>
                            <img src={leadslist} />
                        </Link>
                    </div> */}
                    <h2>Leads Management</h2>
                </div>
                <div className='sub-nav__right'>
                    <div className="sub-nav__buttons">
                        <Button
                            variant="outlined"
                            endIcon={<FileDownload />}
                            onClick={() => handleDownloadExcel(filters)}
                            className='app-btn app-new-btn'
                        // className="download-excel-btn"
                        >
                            <img src='https://cdn-icons-png.flaticon.com/512/888/888850.png' alt='excel_image' width={'20px'} height={'20px'} />
                        </Button>
                    </div>
                    <div className='sub-nav__buttons sub-nav__buttons2'>
                        {isSearchLeadVisible ?
                            <input
                                className='input-search'
                                onMouseEnter={() => setIsSearchLeadVisible(true)}
                                onMouseLeave={() => setIsSearchLeadVisible(false)}
                                value={searchLead}
                                onChange={e => setSearchLead(e.target.value)}
                                type="text"
                                placeholder="Search By Name"
                                style={{
                                    border: '1px solid #ccc',
                                    padding: '5px',
                                    borderRadius: '4px',
                                    marginRight: '4px'
                                }}
                            />
                            : undefined
                        }

                        <a href="#" className="search-btn" onClick={() => setIsSearchLeadVisible(!isSearchLeadVisible)} >
                            <img src={search} />
                        </a>
                    </div>
                    {/* <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn'><img src={pdf} /></Button>
                    </div> */}
                    <div className='sub-nav__buttons'>
                        <Button
                            variant="contained"
                            className={`app-btn app-new-btn ${filtersApplied ? 'filter-applied' : ''}`}
                            onClick={handleFilterClick}
                            aria-describedby={filterId}
                        >
                            <img src={filter} />
                        </Button>

                        <Popover
                            id={filterId}
                            open={isFilterOpen}
                            anchorEl={filterAnchorEl}
                            onClose={handleFilterClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <div className="filter-popover">
                                <div className="filter-header">
                                    <Typography variant="h6">Filter Leads</Typography>
                                    <IconButton size="small" onClick={handleFilterClose}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </div>
                                <Divider />
                                <div className="filter-content">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="employee-filter-label">Created By</InputLabel>
                                                <Select
                                                    labelId="employee-filter-label"
                                                    name="employeeId"
                                                    value={filters.employeeId}
                                                    onChange={handleFilterChange}
                                                    label="Created By"
                                                >
                                                    <MenuItem value="">All Employees</MenuItem>
                                                    {employees.map(emp => (
                                                        <MenuItem key={emp._id} value={emp._id}>
                                                            {emp.Name || emp.firstName + ' ' + emp.lastName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Date Range
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                label="From"
                                                type="date"
                                                name="startDate"
                                                value={filters.startDate}
                                                onChange={handleFilterChange}
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                                fullWidth
                                                inputProps={{ max: new Date().toISOString().split("T")[0] }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                label="To"
                                                type="date"
                                                name="endDate"
                                                value={filters.endDate}
                                                onChange={handleFilterChange}
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                                fullWidth
                                                inputProps={{
                                                    min: filters.startDate
                                                        ? new Date(filters.startDate).toISOString().split("T")[0]
                                                        : undefined,
                                                    max: new Date().toISOString().split("T")[0]
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <Divider />
                                <div className="filter-actions">
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={clearFilters}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={applyFilters}
                                        color="primary"
                                    >
                                        Apply
                                    </Button>
                                </div>
                            </div>
                        </Popover>
                    </div>
                    <div className='sub-nav__buttons'>
                        <Button variant="contained" className='app-btn app-new-btn app-new-btn3' onClick={handleClickOpen}>
                            <AddRoundedIcon />New lead
                        </Button>

                        {open && (
                            <AddLead isPopup={open} setPopup={setOpen} setTriggerRefresh={setTriggerRefresh} />
                        )}
                    </div>
                </div>
            </div>
            <div className='main-body'>
                <Outlet context={[triggerRefresh, setTriggerRefresh, searchLead, filters, rows]} />
            </div>
        </div>
    );
};

export default Leads;
